import z from 'zod';

import { ApiCountrySchema } from '../countries';

import { ApiDimensionSchema } from './models';
import { StandardDimension } from './viewModels';

export const DimensionsAndCountriesResponseSchema = z
  .object({
    countries: z.array(ApiCountrySchema),
    dimensions: z.array(ApiDimensionSchema),
  })
  .transform((data) => {
    const dimensions: StandardDimension[] = [];
    for (const dimension of data.dimensions) {
      const { manualEntryPrefix, manualEntrySource, manualEntryAllowedType, ...restOfUiFlags } =
        dimension.uiFlags ?? {};

      dimensions.push({
        id: dimension.id,
        dimensionId: dimension.id,
        friendlyName: dimension.friendlyName,
        source: 'dimensions',
        type: dimension.type ?? 'Any',
        group: dimension.uiGrouping ?? 'Dimensions',
        sourceGroup: dimension.propertySourceCategory,
        uiFlags:
          dimension.id === '4llTG5'
            ? {
                showInConsentCategory: false,
                showInConsentTagMapping: false,
                showInSegments: true,
                showInDimensions: false,
                showInBestPracticeCustomization: false,
                showInQualifiers: false,
              }
            : {
                ...restOfUiFlags,
                showInSegments: dimension.uiFlags?.showInSegments ?? true,
                showInDimensions: dimension.uiFlags?.showInDimensions ?? true,
              },
        manualEntryPrefix,
        manualEntrySource: manualEntrySource ?? undefined,
        manualEntryAllowedType,
        eventType: dimension.id === '4llTG5' ? 'pii' : dimension.eventType,
        variableName: dimension.variableName,
      });
    }
    return {
      ...data,
      dimensions,
    };
  });

export type DimensionsAndCountriesResponse = z.infer<typeof DimensionsAndCountriesResponseSchema>;
